export const coverages = [
    {value: "miasto", label: "miasto"},
    {value: "województwo", label: "województwo"},
    {value: "region", label: "region"},
    {value: "kraj", label: "kraj"},
    {value: "zagranica-Europa", label: "zagranica - Europa"},
    {value: "zagranica-poza Europą", label: "zagranica - poza Europą"},
]